import * as App from '../../app';
import * as SDK from '../../lib/sdk';
import * as Backend from '../../backend-api';
import { Modal } from '../../lib/components';
import { MOVES_HISTORY_SIZE, getPopupTimeout } from '../const/game';
export function game(props) {
    props.game.on('gameOver', function (_a) {
        var _b, _c, _d;
        var isRecord = _a.isRecord, isAbsoluteRecord = _a.isAbsoluteRecord, score = _a.score, preview = _a.preview, rotateCounter = _a.rotateCounter, historySize = _a.historySize;
        setTimeout(function () {
            var canCancel = historySize === MOVES_HISTORY_SIZE && SDK.Ad.isAvailableRw() && App.features.CANCEL_MOVES_FEATURE;
            props.endGameScreen().show(score, preview.canvas, isRecord, isAbsoluteRecord, canCancel);
        }, getPopupTimeout());
        if (App.features.CANCEL_MOVES_FEATURE) {
            SDK.Ad.checkRw();
        }
        if (isAbsoluteRecord) {
            customSetLeaderBoardScore(score);
        }
        App.stat.params({
            end: (_b = {}, _b[isAbsoluteRecord ? 'win' : 'loss'] = 1, _b),
            theme: (_c = {}, _c[App.themes.get().name] = 1, _c),
            sound: (_d = {}, _d[App.storage.get().mute ? 'off' : 'on'] = 1, _d),
            rotate: rotateCounter,
        });
        if (App.features.SAVE_STATE_FEATURE) {
            Backend.saveStateOnServer(App.storage.get());
        }
    });
    props.game.on('HighScore', function (_a) {
        var absolute = _a.absolute, score = _a.score;
        if (DEVELOPMENT && location.search.includes('promo')) {
            return;
        }
        if (App.settings.get().showNativeOnHighScore) {
            App.Fn.showNative();
        }
        if (absolute) {
            customSetLeaderBoardScore(score);
        }
    });
    props.game.on('click-rating', function () {
        if (Modal.opened === 0) {
            App.sounds.clickButton();
            props.leaderBoard().show();
        }
    });
    if (App.features.FIGURINES_WITH_STARS) {
        props.game.on('star', function (_a) {
            var coins = _a.coins;
            Backend.starBonus(coins).then(function (res) {
                App.Fn.updateCoins(res.balance);
            });
        });
    }
    props.game.on('move', function (_a) {
        var gameOver = _a.gameOver, countAdded = _a.countAdded, countDeleted = _a.countDeleted, countStars = _a.countStars;
        if (gameOver || countDeleted > 0 || countAdded < 1 || countStars > 0 || !App.Fn.checkNative()) {
            return;
        }
        if (!App.settings.get().showNativeAfterMove) {
            if (DEVELOPMENT)
                console.log('Реклама не будет показана. showNativeAfterMove = false.');
            return;
        }
        App.Fn.showNativeAfterTimer(props.game);
    });
}
function customSetLeaderBoardScore(score) {
    var url = FOR_VK ? 'https://functions.yandexcloud.net/d4e6avcdd9irdj43chio' : '';
    SDK.LeaderBoard.setScore('score', score, false, url);
    SDK.Data.save('maxScore', Math.max(score, App.storage.get().maxScore));
}
